// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccounttypeController from "./accounttype_controller"
application.register("accounttype", AccounttypeController)

import CategorySelectorController from "./category_selector_controller"
application.register("category-selector", CategorySelectorController)

import ContactsController from "./contacts_controller"
application.register("contacts", ContactsController)

import CreditnoteController from "./creditnote_controller"
application.register("creditnote", CreditnoteController)

import CustomerController from "./customer_controller"
application.register("customer", CustomerController)

import DocumentController from "./document_controller"
application.register("document", DocumentController)

import ExpertisesController from "./expertises_controller"
application.register("expertises", ExpertisesController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import JobappController from "./jobapp_controller"
application.register("jobapp", JobappController)

import GuestController from "./spending_contact_controller"
application.register("spending_contact", GuestController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PositioncategoriesController from "./positioncategories_controller"
application.register("positioncategories", PositioncategoriesController)

import ReceiptsController from "./receipts_controller"
application.register("receipts", ReceiptsController)

import RelevancecategoryController from "./relevancecategory_controller"
application.register("relevancecategory", RelevancecategoryController)

import RelevanceController from "./relevance_controller"
application.register("relevance", RelevanceController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)

import TaskController from "./task_controller"
application.register("task", TaskController)

import TransactionController from "./transaction_controller"
application.register("transaction", TransactionController)
